import { render, staticRenderFns } from "./PermissionItemsList.vue?vue&type=template&id=02238506"
import script from "./PermissionItemsList.vue?vue&type=script&lang=ts"
export * from "./PermissionItemsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports